/** @module Apparel/ProductSize/SizeRangeSizesRenderer */
define([
	"dojo/_base/declare",
	"./_SizesRenderer",
], function(declare,_SizesRenderer) {

	return declare(_SizesRenderer, {
		/**
		 * @override
		 * If shown in view other than home view of size ranges, then return empty so all sizes are shown individually (no ranges);
		 * If show in home view of size ranges, then only show ranges for 2d or composite size ranges since single dimension sizes 
		 * can contain many separate sets of sizes (10-30, XS-XL, etc.)
		 */
		getSizeRangeDimension1Urls: function(view, sizeRange, sizeRangeSizeSet) {
			if (view.get2dSizeSet && (sizeRange.IsTwoDim || sizeRange.SizeChartSubranges.length)) {
				return this.inherited(arguments);
			}

			return [];
		},

		/**
		 * @override
		 * Return size set that includes available 2d sizes in the system rather than just the sizes chosen for the size range
		 */
		getSizeRangeSizeSet: function(view, sizeRange) {
			if (sizeRange.IsTwoDim && view.get2dSizeSet) {
				return view.get2dSizeSet(sizeRange);
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Size Range is the node in context
		 */
		getSizeRange: function(ctx) {
			return ctx.getNode();
		}
	});
});
